export default __webpack_public_path__ + "static/media/Elsa 9781408342640.8554b958.jpg";